import { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, Divider } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
//import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../services/session';
import { useAuthSession } from '../../contexts/AuthSessionContext';

const menuPaperSx = {
  mt: 1.25,
  minWidth: 232,
  borderRadius: '18px',
  border: '1px solid rgba(15, 23, 42, 0.06)',
  background: 'linear-gradient(180deg, #ffffff 0%, #fafbfd 100%)',
  boxShadow:
    '0 28px 56px -12px rgba(15, 23, 42, 0.28), 0 0 0 1px rgba(15, 23, 42, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.9)',
  overflow: 'visible',
  '& .MuiList-root': {
    py: 0.75,
  },
  '& .MuiMenuItem-root': {
    mx: 0.75,
    px: 1.25,
    py: 1,
    borderRadius: '10px',
    fontSize: '0.92rem',
    fontWeight: 500,
    color: '#1e293b',
    transition: 'background 0.18s ease, color 0.18s ease, padding-left 0.2s ease',
  },
  '& .MuiMenuItem-root .MuiListItemIcon-root': {
    minWidth: 30,
    color: '#64748b',
    transition: 'color 0.18s ease, transform 0.18s ease',
  },
  '& .MuiMenuItem-root .MuiSvgIcon-root': {
    fontSize: 19,
  },
  '& .MuiMenuItem-root:hover': {
    background:
      'linear-gradient(90deg, rgba(8, 145, 178, 0.10) 0%, rgba(8, 145, 178, 0.03) 100%)',
    color: '#0f172a',
    paddingLeft: '18px',
  },
  '& .MuiMenuItem-root:hover .MuiListItemIcon-root': {
    color: '#0891b2',
    transform: 'scale(1.05)',
  },
  '& .MuiMenuItem-root.danger': {
    color: '#b91c1c',
  },
  '& .MuiMenuItem-root.danger:hover': {
    background:
      'linear-gradient(90deg, rgba(239, 68, 68, 0.10) 0%, rgba(239, 68, 68, 0.03) 100%)',
    color: '#991b1b',
  },
  '& .MuiMenuItem-root.danger:hover .MuiListItemIcon-root': {
    color: '#dc2626',
  },
};

const SettingsMenuButton = ({ buttonProps = {}, beforeNavigate = () => true }) => {
  const navigate = useNavigate();
  const {
    isOwner,
    atendabotAtendente,
    hasProductAccess,
  } = useAuthSession();
  const isAtendabotManager =
    atendabotAtendente !== true
    && typeof hasProductAccess === 'function'
    && hasProductAccess('atendabot');
  const canManageUsers = isOwner || isAtendabotManager;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    if (!beforeNavigate('/')) return;
    await logoutUser();
    navigate('/');
  };

  return (
    <>
      <IconButton onClick={handleMenuOpen} aria-label="settings" {...buttonProps}>
        <SettingsIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: menuPaperSx }}
      >
        {isOwner && (
          <MenuItem
            onClick={() => {
              if (!beforeNavigate('/conta')) return;
              handleMenuClose();
              navigate('/conta');
            }}
          >
            <ListItemIcon>
              <AccountCircleOutlinedIcon />
            </ListItemIcon>
            Minha conta
          </MenuItem>
        )}
        {canManageUsers && (
          <MenuItem
            onClick={() => {
              if (!beforeNavigate('/usuarios')) return;
              handleMenuClose();
              navigate('/usuarios');
            }}
          >
            <ListItemIcon>
              <ManageAccountsOutlinedIcon />
            </ListItemIcon>
            Usuários
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            if (!beforeNavigate('/alterar-senha')) return;
            handleMenuClose();
            navigate('/alterar-senha');
          }}
        >
          <ListItemIcon>
            <LockOutlinedIcon />
          </ListItemIcon>
          Alterar senha
        </MenuItem>
        {/* {isOwner && (
          <MenuItem
            onClick={() => {
              handleMenuClose();
              navigate('/unidades');
            }}
          >
            <ListItemIcon>
              <StorefrontOutlinedIcon />
            </ListItemIcon>
            Unidades
          </MenuItem>
        )} */}
        <Divider sx={{ my: 0.5, mx: 1.5, borderColor: 'rgba(15, 23, 42, 0.06)' }} />
        <MenuItem
          className="danger"
          onClick={async () => {
            handleMenuClose();
            await handleLogout();
          }}
        >
          <ListItemIcon>
            <LogoutOutlinedIcon />
          </ListItemIcon>
          Sair
        </MenuItem>
      </Menu>
    </>
  );
};

export default SettingsMenuButton;
